import * as yup from 'yup';

export const billingAddressInitialValues = {
  firstName: '',
  lastName: '',
  address1: '',
  address2: '',
  city: '',
  country: '',
  state: '',
  zip: '',
  email: '',
  phone: '',
};

export const billingAddressValidation = yup.object().shape({
  firstName: yup.string().required('First Name is required'),

  lastName: yup.string().required('Last Name is required'),

  address1: yup.string().required('Address 1 is required'),

  city: yup.string().required('City is required'),

  country: yup.string().required('Country is required'),

  state: yup.string().required('State is required'),

  zip: yup.string().required('Zip is required'),

  email: yup
    .string()
    .required('Email is required')
    .email('Email must be valid'),

  phone: yup.string().required('Phone is required'),
});
